import React, { useState } from "react";
import "./ImageViewer.css";
import { TbChevronLeft, TbChevronRight, TbX } from "react-icons/tb";
import { Container, Flex, SafeArea } from "../../layout";
import { Image, Button, Text } from "../";

/**
 * Composant ImageViewer
 *
 * Un visionneur d'images réactif permettant aux utilisateurs de voir une image en plein écran,
 * de naviguer entre les images à l'aide des flèches gauche et droite, et d'afficher l'index actuel.
 *
 * @param {Object} props - Les propriétés du composant.
 * @param {Array<string>} props.images - Tableau d'URL d'images à afficher dans le visionneur.
 * @param {Function} props.closeViewer - Fonction appelée pour fermer le visionneur.
 */
function ImageViewer({ images, closeViewer, index = 0 }) {
  // État pour suivre l'index de l'image actuellement affichée.
  const [currentIndex, setCurrentIndex] = useState(index || 0);
  const totalImages = images?.length;

  // Gestionnaire de clic pour passer à l'image suivante.
  const handleNext = () =>
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);

  // Gestionnaire de clic pour revenir à l'image précédente.
  const handlePrev = () =>
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalImages) % totalImages);

  // Gestionnaire de clic pour fermer le viewer si le clic est à l'extérieur des éléments ciblés
  const handleClickOutside = (e) => {
    if (!e.target.closest(".arrow, .fullscreen-image, .numbers")) {
      closeViewer();
    }
  };

  return (
    <Container className="ImageViewer" onClick={handleClickOutside}>
      <SafeArea className="wrapper">
        <Flex type="between-center" className="header">
          <Container className="border">
            <Button
              skin="dark"
              className="close-btn"
              iconLeft={<TbX />}
              onClick={closeViewer}
            >
              Fermer
            </Button>
          </Container>
          <Text size="sm" className="numbers">{`${
            currentIndex + 1
          } / ${totalImages}`}</Text>
          <Container className="border"></Container>
        </Flex>
        <Flex className="fullscreen-viewer">
          <Image
            src={images[currentIndex]}
            alt={`Image ${currentIndex + 1}`}
            className="fullscreen-image"
          />
        </Flex>
        <Flex type="between-center" gap={20} className="arrows">
          <Button skin="nobg" className="prev-btn arrow" onClick={handlePrev}>
            <TbChevronLeft className="icon" />
          </Button>
          <Button skin="nobg" className="next-btn arrow" onClick={handleNext}>
            <TbChevronRight className="icon" />
          </Button>
        </Flex>
      </SafeArea>
    </Container>
  );
}

export default ImageViewer;
